import src from './src';

export default src;


// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-error-handling/index.js